export default __webpack_public_path__ + "static/media/dockingStation.a32d4fa5.svg";